export default "__VITE_ASSET__BNplzNxA__"